import React from 'react'


import {API_BASE_URL} from '../../constants'
import axios from 'axios'

import ReactTable  from "react-table";
import {getToken} from '../../storage'

class DiscountFormat extends React.Component {

  render() {
    let discount = this.props.discount
    if(typeof discount !== "undefined") {

      if(discount.is_percentage) {
        return "(%)" + discount.rate
      }
      else {
        return <div>&#8377; {discount.value}</div>
      }
    }
    else {
      return null
    }

  }

}

export default class DiscountList extends React.Component {


  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreateDiscount = this.goToCreateDiscount.bind(this)
    document.title = "Discount List"
  }

  goToCreateDiscount(e) {
    e.preventDefault()
    this.props.history.push("/discounts/create/")
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/discounts/edit/'+row.original.serial)
      },
      style: {
        cursor:'pointer'
      }
    }
  }



    fetchData(state, instance) {
      this.setState({ loading: true });
      let apiurl = "/list_discounts/?page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.discounts,
          pages: res.data.pages,
          loading: false
        });
      });
    }


    render() {
      const { data, pages, loading } = this.state;
      const columns = [
        {Header:'Min Quantity',  accessor:'quantity',sortable:true},
        {Header:'Discount',  accessor:'summary_totalTax', sortable:true, Cell:(row)=>(<DiscountFormat discount={row.original}/>) }

      ]
      const defaultSort=[{id: "serial", desc: true}]
      return <div><section className="medium">
        <ul className="list-inline">
          <li><button onClick={this.goToCreateDiscount} className="btn btn-primary">Create New Discount</button></li>
        </ul>
      </section>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Discounts Found."
                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/discount/discountlist.js